// Full-width section with a background image overlaid in a red brand tone.
export const RedImageBand = ({ image, eyebrow, title, children, testid = "red-image-band", imageAlt }) => {
  return (
    <section data-testid={testid} className="relative isolate overflow-hidden bg-black py-20 text-white sm:py-28">
      {image && (
        <img src={image} alt={imageAlt || title || "Trilogy Sports & Fitness"} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      )}
      {/* Red tone overlay */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(115deg, hsl(var(--brand-red-deep)) 0%, hsl(var(--brand-red) / 0.72) 45%, rgba(0,0,0,0.82) 100%)",
        }}
      />
      <div className="absolute inset-0 bg-black/25" />
      <div className="relative mx-auto w-full max-w-5xl px-4 sm:px-6">
        {eyebrow && <div className="font-condensed text-xs font-semibold uppercase tracking-[0.25em] text-white/80">{eyebrow}</div>}
        {title && <h2 className="mt-2 display-title text-4xl sm:text-5xl lg:text-6xl">{title}</h2>}
        {children && <div className="mt-4">{children}</div>}
      </div>
    </section>
  );
};
